import React from 'react'
import { FaFutbol,FaEdit } from "react-icons/fa";

const GoalResultMobile = (props) => {
    const { goalResultList } = props;
    return (
        <div className='flex flex-col p-2'>
            {
                goalResultList && goalResultList.map((v,i) => { 
                    return (
                        <div key={i} className={`${v.isDiff ? 'bg-yellow-300 dark:bg-customLightYellow2' : null} mb-2 rounded-lg border border-slate-600 shadow-md`}>
                            <div className="pb-2">
                                <div className='flex justify-between py-0'>
                                    <span className="text-xs flex items-center gap-1 text-customFontGreen ml-1"><FaFutbol />{v.eventTime}</span>
                                    {/* {
                                    (!v.finished555 && v.status909 === "0") || (v.homeGoal909 === v.homeGoal555 && v.awayGoal909 === v.awayGoal555) ?
                                   null
                                    : <Radio
                                   checked={selectedValue === v.eventId909}
                                   onChange={(e)=>handleChange(e.target.value,'909')}
                                   value={v.eventId909}
                                   name="radio-buttons"
                                   inputProps={{ 'aria-label': v.eventId909 }}
                                 />
                                } */}
                                </div>
                                <div className='flex'>
                                    <div className="flex justify-center w-[35%] text-sm text-customFontVoilet font-medium">{v.homeTeam909}</div>
                                    <div className="flex flex-col justify-center items-center w-[30%]">
                                        <div className={`${ v.homeGoal909 === "PP" ? 'text-customFontRed' : v.isDiff ? 'text-teal-700 dark:text-customBlack' : 'text-teal-700 dark:text-customWhite'} px-2 rounded-xl`}>
                                            <b className='text-base'>
                                                {v.homeGoal909} -  {v.awayGoal909}
                                            </b>
                                        </div>
                                        <span className='font-bold text-blue text-[0.77rem] italic'>Sport909</span>
                                    </div>
                                    <div className="flex justify-center w-[35%] text-sm text-customFontVoilet font-medium">{v.awayTeam909}</div>
                                </div>
                            </div>
                            <div className="border-t border-t-slate-700 pb-2">
                                <div className='flex justify-between'>
                                    <span className="text-xs flex items-center gap-1 text-customFontGreen ml-1"><FaFutbol />{v.eventTime}</span>
                                    {/* {
                                     (!v.finished555 && v.status909 === "0") || (v.homeGoal909 === v.homeGoal555 && v.awayGoal909 === v.awayGoal555) ?
                                 null
                                  :  <Radio
                                  checked={selectedValue === v.eventId555}
                                  onChange={(e)=>handleChange(e.target.value,'555')}
                                  value={v.eventId555}
                                  name="radio-buttons"
                                  inputProps={{ 'aria-label': v.eventId555 }}
                                />} */}
                                </div>
                                <div className='flex'>
                                    <span className="flex justify-center w-[35%] text-sm text-customFontVoilet font-medium">{v.homeTeam555}</span>
                                     <div className="flex flex-col justify-center items-center w-[30%]">
                                        <div className={`${v.finished555.toLowerCase() === "true" && v.canceled === "true" ? 'text-customFontRed' : v.isDiff ? 'text-teal-700 dark:text-customBlack' : 'text-teal-700 dark:text-customWhite'} px-2 rounded-xl`}>
                                            <b className='text-base'>
                                                 {v.finished555.toLowerCase() === "true" ? v.canceled === "true" ? "PP" : v.homeGoal555 : 'NE'} -   {v.finished555.toLowerCase() === "true" ? v.canceled === "true" ? "PP" : v.awayGoal555 : 'NE'}
                                            </b>
                                        </div>
                                        <span className='font-bold text-customFontLightGreen text-[0.77rem] italic'>555Mix</span>
                                    </div>
                                    <span className="flex justify-center w-[35%] text-sm text-customFontVoilet font-medium">{v.awayTeam555}</span>
                                </div>
                                
                            </div>
                            {/* <td className="border border-slate-300 px-2">
                                {
                                   (v.finished555 === "false" && v.status909 === "0") || (v.homeGoal909 === v.homeGoal555 && v.awayGoal909 === v.awayGoal555) ?
                                  <Button variant="contained" size='medium' disabled>Save</Button> :
                                  <Button variant="contained" size='medium' onClick={()=>handleOpen(v.eventId909)}>Save</Button>
                                }
                              </td> */}
                        </div>
                    )
            })
            }
        </div>
    )
}

export default GoalResultMobile;